import type { TraitName } from '@atlassian/jira-traits/src/types.tsx';

export type ModalProps = {
	projectId: string;
};

export const IS_FOUNDER_TRAIT: TraitName = 'is_founder';
export const JSW_ACTIVATION_DATE_TRAIT: TraitName = 'jira-software.ondemand.activationDate';
export const JIRA_FIRST_ACTIVE_TRAIT: TraitName = 'jira_first_active';
export const NTH_USER_WELCOME_MODAL_VIEWED_TRAIT = 'nth_user_welcome_modal_viewed'; // TODO: Add to TraitName type

export type SiteTraits = {
	jiraActivationDate?: string;
};

export type SiteUserTraits = {
	isFounder?: boolean;
	jiraFirstActive?: string;
	hasViewedNthUserWelcomeModal?: boolean;
};

export const TWENTY_FOUR_HOURS_MS = 24 * 60 * 60 * 1000;
export const TWENTY_FOUR_HOURS_FIVE_MINS_MS = (24 * 60 * 60 + 5 * 60) * 1000; // 24 hours 5 minutes

export const CanShowNthUserWelcomeModalReason = {
	NONE: 'none',
	IS_FOUNDER: 'isFounder',
	HAS_VIEWED_NTH_USER_WELCOME_MODAL: 'hasViewedNthUserWelcomeModal',
	QUERY_PARAM_PRESENT: 'queryParamPresent',
	USER_FIRST_ACTIVE_IN_JIRA_DATE_LESS_THAN_24_HOURS_AND_5_MINUTES_AGO:
		'userFirstActiveInJiraDateLessThan24HoursAnd5MinutesAgo',
	USER_FIRST_ACTIVE_IN_JIRA_DATE_GREATER_THAN_24_HOURS:
		'userFirstActiveInJiraDateGreaterThan24Hours',
	JIRA_ACTIVATION_DATE_LESS_THAN_24_HOURS_AND_5_MINUTES_AGO:
		'jiraActivationDateLessThan24HoursAnd5MinutesAgo',
	JIRA_ACTIVATION_DATE_NOT_PRESENT: 'jiraActivationDateNotPresent',
	JIRA_FIRST_ACTIVE_NOT_PRESENT: 'jiraFirstActiveNotPresent',
	ERROR_FETCHING_SITE_TRAITS: 'errorFetchingSiteTraits',
	ERROR_FETCHING_SITE_USER_TRAITS: 'errorFetchingSiteUserTraits',
};

export const NTH_USER_WELCOME_MODAL_SOURCE_NAME = 'nthUserWelcome';
